import { render, staticRenderFns } from "./EbookContentDashboard.vue?vue&type=template&id=92a842c0&scoped=true"
import script from "./EbookContentDashboard.vue?vue&type=script&lang=js"
export * from "./EbookContentDashboard.vue?vue&type=script&lang=js"
import style0 from "./EbookContentDashboard.vue?vue&type=style&index=0&id=92a842c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a842c0",
  null
  
)

export default component.exports